import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { selectImage } from "@/jsUtils/selectImage";
import { post_Json } from "@/jsUtils/nodejsRequest";
import { UploadFilled } from "@element-plus/icons-vue";
import { PageType } from "@/globalcfg.js";
import { blobToBase64 } from "@/jsUtils/fileConvert";

// import uuidv1 from "uuid/v1";
import { v1 as uuidv1 } from 'uuid';
// import blankBottom from "@/components/tiny/blankBottom.vue";
import { getLocalImagePath } from "@/lang/getLocalImg.js";
export default {
  emits: ["onBeforeUpload", "onUploadSucceed", "onUploadFailed", "startcrop", "onReceiveParticelResult", "onReceiveParticelEnd"],
  components: {
    UploadFilled
    // Popup,                 // 弹窗,自定义组件一定要在这里注册
    // CrooperImg,                   // 裁剪图片的组件
    // blankBottom,                  // 空白底部
  },

  data() {
    return {
      imageUrl: "",
      //上传后裁剪的图片
      imagebase64: undefined,
      cropBox: undefined,
      //裁剪框数据，格式为{top:0,left:0,width:0,height:0}
      // leftImgFile: undefined,
      // rightImgFile: undefined,
      imgIsChanged: false,
      //图片是否发送变更
      visibleTip: false,
      //是否显示提示
      tipContent: "",
      //提示内容
      triggerRef: undefined,
      //提示所依附元素
      showCutImg: false,
      imgWillCut: "",
      responseText: '',
      //后台返回的提示信息，用于显示在提示框中

      upload_btn: getLocalImagePath('imagetrans_upload_button'),
      //上传按钮
      loading_gif: require("@/assets/public/loading.gif"),
      show_blank: true,
      PageType: PageType,
      //全局配置的页面类型
      origin_image_base64: undefined,
      //原始图片的base64

      showImagetrans_tile: true
    };
  },
  props: {
    uploadUrl: {
      Type: String
    },
    defaultLeftImgUrl: {
      Type: String
    },
    defaultRightImgUrl: {
      Type: String
    },
    createButImg: {
      Type: String,
      required: true
    },
    // 上传图片的产品类型
    product_type: {
      Type: String,
      required: true
    }
  },
  computed: {
    // 裁剪说明时，根据不同的页面显示不同的裁剪说明标题
    Show_Crop_title() {
      let pathname = window.location.pathname;
      if (pathname == "/")
        // 获得当前的页面路径
        {
          // return this.$t('messages.main_try_upload');
          this.showImagetrans_tile = false;
        } else {
        this.showImagetrans_tile = true;
        return this.$t('messages.product_try_upload');
      }
    },
    Show_Crop_Detail() {
      let pathname = window.location.pathname;
      if (pathname == "/")
        // 获得当前的页面路径
        {
          return this.$t('messages.main_try_upload_detail');
        } else {
        return this.$t('messages.product_try_upload_detail');
      }
    }
  },
  mounted() {
    this.responseText = '';
  },
  methods: {
    //选择文件
    handleSelect() {
      // console.log("handleSelect ****** ");

      let self = this;
      self.visibleTip = false;
      selectImage(undefined, img => {
        // console.log("selectImage callback ****** ");

        //文件转换为url
        let url = URL.createObjectURL(img);

        //标识变更
        this.imgIsChanged = true;
        this.showCutImg = true;
        this.imgWillCut = url;
        let imgurl = url;
        // imagecrop(url);
        // this.$refs.cutImg.onStartCrop(url);          //调用子组件
        this.$emit("startcrop", imgurl); //调用父组件

        blobToBase64(img).then(orgin_base64 => {
          this.origin_image_base64 = orgin_base64;
        });
      });

      // console.log("handleSelect ****** end");
    },

    //上传文件
    handleUpload() {
      if (!this.imageUrl) {
        this.showTip(this.$refs.imageSelectBut, "Please upload a picture");
      } else if (!this.imgIsChanged) {
        this.showTip(this.$refs.createBut, "It is currently up to date,whether to change the picture?");
      } else if (this.uploadUrl) {
        //  先显示裁剪图
        $("#previewUI").show();
        // 再显示加载图标
        $("#loading-ui").show();
        // 清空提示信息
        this.responseText = '';
        this.$refs.loadingImg.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest"
        });
        this.$emit("onBeforeUpload");
        let uuidkey = uuidv1();
        let senddata = {
          image_base64: this.imagebase64,
          uuid: uuidkey,
          product: this.product_type,
          page: this.PageType,
          cropbox: this.cropBox,
          origin_image_base64: this.origin_image_base64
        };

        // console.log("send ------data :", senddata);
        // console.log("send url :", this.uploadUrl);

        if (this.product_type == "AllProducts") {
          this.Upload_byFetch(this.uploadUrl, senddata);
        } else {
          this.Upload_byJson(this.uploadUrl, senddata);
        }

        // 记录上传日志
        let uploadevt = {
          "image_name": uuidkey,
          "product_name": this.product_type
        };
        this.sendStatisticData(uploadevt);
      } else {
        console.error("uploadUrl is null.");
      }
    },
    Upload_byFetch(uploadUrl, senddata) {
      // 隐藏加载图标, 所有产品的页面，加载图标由页面控制，而不在组件中控制
      $("#loading-ui").hide();

      // 使用fetch上传数据
      fetch(uploadUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(senddata)
      }).then(response => {
        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");
        let chunks = [];
        let partialData = "";
        let vm = this; // 保存this指针，否则在回调函数中无法使用this

        function processChunk({
          done,
          value
        }) {
          if (done) {
            // console.log("Stream complete");
            if (partialData) {
              // console.log("final partial data:", partialData);
              let result = JSON.parse(partialData);
              let retobj = {
                res: result,
                origingimgbase64: vm.imagebase64
              };
              vm.$emit("onReceiveParticelResult", retobj);
            }

            // 间隔200ms后隐藏加载图标
            setTimeout(() => {
              $("#loading-ui").hide();
              // 通知父组件上传完成
              vm.$emit("onReceiveParticelEnd");
            }, 200);
            return;
          }

          // console.log("received data:", value);
          partialData += decoder.decode(value);
          let lines = partialData.split("\r\n");
          for (let i = 0; i < lines.length - 1; ++i) {
            let line = lines[i];
            if (line) {
              // console.log("line:", line);
              let result = JSON.parse(line);
              let retobj = {
                res: result,
                origingimgbase64: vm.imagebase64
              };
              vm.$emit("onReceiveParticelResult", retobj);
            }
          }
          partialData = lines[lines.length - 1];
          // 继续读取下一个数据块
          return reader.read().then(processChunk);
        }
        return reader.read().then(processChunk);
      }).catch(err => {
        console.error('fetch error: ', err);
      });
    },
    Upload_byJson(uploadUrl, senddata) {
      //上传数据到后台
      post_Json(uploadUrl, senddata).then(res => {
        // console.log("upload succeed");
        // console.dir(res);
        // console.log("response data length:", res.data.length);

        if (res.data.length == 0 || res.data.length == undefined) {
          // console.log("upload failed, message:", res.data.message);
          this.responseText = res.data.message;
          // 隐藏加载图标
          $("#loading-ui").hide();
          this.$refs.responsemessage.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "nearest"
          });
          return;
        }
        let retobj = {
          res: res,
          origingimgbase64: this.imagebase64
        };

        // 下载响应数据
        // this.download(retobj);

        this.$emit("onUploadSucceed", retobj);
        this.imgIsChanged = false;

        // 隐藏加载图标
        $("#loading-ui").hide();
      }, err => {
        this.$emit("onUploadFailed", err);
      });
    },
    //发送统计数据
    sendStatisticData(uploadevent) {
      let data = {
        "event": "product_upload",
        "data": uploadevent
      };
      let stat_url = '/imageprocesshost' + '/statistic';
      post_Json(stat_url, data).then(res => {
        // 不做任何事情
      });
    },
    //显示提示
    showTip(target, content) {
      this.triggerRef = target;
      this.tipContent = content;
      this.visibleTip = true;
      //自动关闭
      setTimeout(() => {
        this.visibleTip = false;
      }, 4000);
    },
    // 裁剪成功
    onCutOk(result) {
      let url = URL.createObjectURL(result.file);
      this.imageUrl = url;
      this.imagebase64 = result.base64;
      this.cropBox = result.cropBox;
      this.showCutImg = false;
      this.show_blank = false;
      this.handleUpload();
    },
    // 取消裁剪
    onCutCancel() {
      this.showCutImg = false;
    },
    // 保存后台处理后的数据
    download(retobj) {
      let content = JSON.stringify({
        retobj
      });
      var blob = new Blob([content], {
        type: "text/plain;charset=utf-8"
      });
      // console.log(blob)
      saveAs(blob, "retobj.json");
    },
    // 显示本地缓存的裁剪图片
    showLocalImage(localCutImage) {
      this.imageUrl = localCutImage;
      this.show_blank = false;
      $("#previewUI").show();
    }
  }
};